import React from "react";
import { FiExternalLink } from "react-icons/fi";
import SimpleTooltip from "./SimpleTooltip";

class OpenLinkInNewWindowWrapper extends React.Component {
  shouldComponentUpdate() {
    return false;
  }

  goTo(href) {
    window.open(href);
  }

  render() {
    const { href, tooltipText } = this.props;
    return (
      <SimpleTooltip tooltipText={tooltipText}>
        <button
          type="button"
          className="flex items-center px-2 hover:text-blue-600"
          onClick={() => this.goTo(href)}
        >
          <FiExternalLink></FiExternalLink>
        </button>
      </SimpleTooltip>
    );
  }
}

export default OpenLinkInNewWindowWrapper;
